<template>
    <div class="add-customer-form">
        <!-- {{mapURL}} -->
        <el-form :label-position="labelPosition" label-width="150px">
            <el-form-item label="企业名称：" required>
                <!-- <el-input 
                    size="medium" 
                    v-model="form.custName"
                    placeholder="请输入企业名称"
                ></el-input> -->
                <el-autocomplete
                    v-model.trim="form.custName"
                    placeholder="请输入企业名称"
                    :fetch-suggestions="querySearchAsync"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                    clearable
                    :popper-class="isShowHide"
                    size="medium"
                    style="width: 100%;"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="企业所在地：" required>
                <el-input 
                    size="medium" 
                    v-model="form.address"
                    placeholder="请选择企业所在地"
                    @focus="openMap"
                ></el-input>
                <!-- <div class="el-input el-input__inner" @click="isShowMap=true">{{form.address}}</div> -->
            </el-form-item>
            <!-- <el-form-item label="省份：" required>
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable 
                    v-model="form.provinceId" 
                    style="width: 100%"
                    @change="getAreaCity"
                >
                    <el-option
                        v-for="(item,index) in provinceList" 
                        :label="item.areaname" 
                        :value="item.aid"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="城市：" required>
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable 
                    v-model="form.cityId" 
                    style="width: 100%"
                >
                    <el-option
                        v-for="(item,index) in cityList" 
                        :label="item.areaname" 
                        :value="item.aid"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址：" >
                <el-input 
                    size="medium" 
                    v-model="form.address"
                    placeholder="请输入详细地址"
                ></el-input>
            </el-form-item> -->
            <el-form-item label="固定电话：" >
                <el-input 
                    size="medium"
                    v-model="form.phone"
                    maxlength="11"
                    placeholder="请输入固定电话"
                ></el-input>
            </el-form-item>
            <el-form-item label="年营业额：" >
                <el-input 
                    size="medium"
                    v-model.number="form.annualTurnover"
                    placeholder="请输入年营业额（万）"
                ></el-input>
            </el-form-item>
            <el-form-item label="所属行业：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable
                    v-model="form.industry"
                    style="width: 100%"
                >
                    <el-option
                        v-for="(item,index) in industrysList"
                        :label="item.industryname" 
                        :value="item.industryid"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="销售负责人：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable
                    v-model="form.salerId"
                    style="width: 100%"
                >
                    <el-option 
                        v-for="(item,index) in fzrList"
                        :label="item.userName" 
                        :value="item.userId"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="外部销售负责人：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable
                    v-model="form.exterSalerId"
                    style="width: 100%"
                >
                    <el-option 
                        v-for="(item,index) in wbfzrList"
                        :label="item.userName" 
                        :value="item.userId"
                        :key="index"
                    >
                        <span style="float:left;min-width:3em;">{{ item.userName }}</span>
                        <span style="float:left;padding-left:10px;">{{ item.handset }}</span>
                        <span style="float:right;padding-left:10px;">{{ item.companyName }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="对接负责人：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable
                    v-model="form.jointerId"
                    style="width: 100%"
                >
                    <el-option 
                        v-for="(item,index) in djfzrList"
                        :label="item.userName" 
                        :value="item.userId"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户成功部负责人：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    filterable
                    v-model="form.custSuccId"
                    style="width: 100%"
                >
                    <el-option 
                        v-for="(item,index) in khcgbffzrList"
                        :label="item.userName" 
                        :value="item.userId"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="主要需求领域：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium"
                    v-model="form.prodDomainId" 
                    style="width: 100%"
                >
                    <el-option 
                        v-for="(item,index) in domianList"
                        :value="item.domainid" 
                        :label="item.domainname" 
                        :key="index" 
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" required>
                <el-input 
                    size="medium"
                    v-model.trim="form.businessLicense"
                    placeholder="请输入统一社会信用代码"
                ></el-input>
            </el-form-item>
            <el-form-item label="产线：" >
                <el-input 
                    size="medium"
                    v-model.trim="form.prodLine"
                    placeholder="请输入产线"
                ></el-input>
            </el-form-item>
            <el-form-item label="预计发单量：" >
                <el-input 
                    size="medium"
                    v-model.number="form.billNumber"
                    placeholder="请输入预计发单量"
                ></el-input>
            </el-form-item>
            <el-form-item label="预计发单金额：" >
                <el-input 
                    size="medium"
                    v-model.number="form.billAmount"
                    placeholder="请输入预计发单金额"
                ></el-input>
            </el-form-item>
            <el-form-item label="预计发单高峰期：" >
                <el-select 
                    placeholder="请选择" 
                    size="medium" 
                    v-model="form.billTime"
                    style="width: 100%"
                >
                    <el-option :value="1" label="第一季度"></el-option>
                    <el-option :value="2" label="第二季度"></el-option>
                    <el-option :value="3" label="第三季度"></el-option>
                    <el-option :value="4" label="第四季度"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="业主方联系人：" >
                <el-input 
                    size="medium"
                    v-model="form.owner"
                    placeholder="请输入业主方联系人"
                ></el-input>
            </el-form-item>
            <el-form-item label="业主方联系电话：" >
                <el-input 
                    size="medium"
                    v-model.number="form.ownerPhone"
                    maxlength="11"
                    placeholder="请输入业主方联系电话"
                ></el-input>
            </el-form-item>
            <el-form-item label=" " style="margin-top: 30px;">
                <el-button size="medium" type="primary" @click="confirmSeas">提交</el-button>
            </el-form-item>
        </el-form>

        <el-dialog
            v-if="isShowMap"
            title="地址选择"
            width="700px"
            append-to-body
            :visible.sync="isShowMap"
            :lock-scroll="false"
        >
            <!-- 250527_gaodeMap 我的客户-新增客户 -->
            <gaodeMap  id="map" class="gaode-map" :cantEdit="true" :pickedAddress="pickedAddress" @gaodemapSubmit="gaodemapSubmit"/>
        </el-dialog>
    </div>
</template>
<script>
    import gaodeMap from "@/components/gaodeMap.vue";
    import {
        // optionsArea,                //省市区
        industrys,                  //所属行业
    } from "@/service/area";
    import {
        optionHeaders,                  //负责人
        prodDomains,                    //获取领域
        aliyunCompanyInfo,              //阿里云查询信息（企业）
        companyExist,                   //企业是否存在
        areaInfoGet,                    //选择完地图之后调用
    } from "@/service/customerInformation";
    export default {
        components: {
            gaodeMap
        },
        data() {
            return {
                labelPosition: 'left',
                form: {
                    custName: '',       //企业（客户）名称
                    provinceId: '',     //省id
                    cityId: '',         //城市id
                    lat: '',            //经
                    lng: '',            //纬




                    address: '',        //详细地址
                    phone: '',          //手机号
                    annualTurnover: '', //年营业额
                    industry: '',       //所属行业

                    salerId: '',        //负责人id
                    exterSalerId: '',   //外部销售负责人id
                    jointerId: '',      //对接负责人id
                    custSuccId: '',     //客户成功部负责人id
                    prodDomainId: '',   //领域id

                    businessLicense: '',//统一社会信用代码
                    prodLine: '',       //产线
                    billNumber: '',     //预计发单量
                    billAmount: '',     //预计发单金额
                    billTime: '',       //预计发单高峰期
                    owner: '',          //业主方联系人
                    ownerPhone: '',     //业主方联系电话


                },
                provinceList: [],
                cityList: [],
                industrysList: [],
                domianList: [],

                fzrList: [],
                wbfzrList: [],
                djfzrList: [],
                khcgbffzrList: [],

                oraginForm: {},
                //企业信息
                timeout: null,
                isShowHide: 'searchHide',
                // END
                // 地图
                isShowMap: false,
                pickedAddress: {}
            };
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
        },
        computed: {
        },
        mounted() {
        },
        methods: {
            get(){
                // this.getOptionArea();
                this.getIndustrys();
                this.getProdDomains();
                for (var x = 1; x < 5; x++) {
                    this.getOptionHeaders(x);
                }
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
            },
            // 获取省
            // getOptionArea(){
            //     let data = {}
            //     data.aid = ''
            //     data.areaType = 1
            //     optionsArea(data).then(res=> {
            //         this.provinceList = res.Data
            //     })
            // },
            // 获取城市
            // getAreaCity(){
            //     let data = {}
            //     data.aid = this.form.provinceId
            //     data.areaType = 2
            //     optionsArea(data).then(res=> {
            //         this.cityList = res.Data
            //     })
            // },
            // 获取行业
            getIndustrys(){
                let data = {}
                data.lvl = 1
                industrys(data).then(res=>{
                    this.industrysList = res.Data
                })
            },
            // 获取负责人 （1=销售负责人，2=外部销售负责人，3=对接负责人，4=客户成功部负责人）
            getOptionHeaders(type) {
                let data = {}
                data.headerType = type
                optionHeaders(data).then(res=> {
                    switch(type){
                        case 1:
                            this.fzrList = res.Data
                            break;
                        case 2:
                            this.wbfzrList = res.Data
                            break;
                        case 3:
                            this.djfzrList = res.Data
                            break;
                        default:
                            this.khcgbffzrList = res.Data
                            break;
                    }
                })

            },
            // 获取领域
            getProdDomains(){
                prodDomains().then(res=>{
                    this.domianList = res.Data
                })
            },
            // 提交
            confirmSeas(){
                let data = Object.assign({}, this.form);
                if(!data.custName) {
                    return this.$message.warning('企业名称不能为空')
                }
                if(!data.address) {
                    return this.$message.warning('请选择企业所在地')
                }
                if(!data.businessLicense) {
                    return this.$message.warning('统一社会信用代码不能为空')
                }
                this.$emit('confirmSeasFun', data)
            },
            // 企业模糊搜索
            querySearchAsync(queryString, cb) {
                if(queryString.length<3){
                    return this.isShowHide = 'searchHide'
                }
                this.isShowHide = ''
                let data = {
                    companyName: queryString,
                }
                aliyunCompanyInfo(data).then(res=> {
                    let companyInfo = []
                    if(res.Data && res.Data.length){
                        for (let i of res.Data) {
                            i.value = i.companyName;
                        }
                        companyInfo = res.Data
                    }
                    if(companyInfo.length === 0) {
                        companyInfo = [{'value': '暂无数据'}]
                    }
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        cb(companyInfo);                                                
                    }, 3000 * Math.random());
                })
            },
            handleSelect(item){
                if(item.value == '暂无数据') {
                    return this.form.custName = ''
                }
                let data = {
                    businessLicense: item.creditCode,
                }
                companyExist(data).then(res=> {
                    if(res.Result != 1) {
                        this.form.custName = ''
                        return this.$message.error(res.Message)
                    }
                    this.form.businessLicense = item.creditCode
                })
            },
            openMap() {
                this.isShowMap=true;
                setTimeout(() => {
                    this.pickedAddress = {
                        FullAddress: this.form.address,
                        Lng: this.form.lng,
                        Lat: this.form.lat,
                    }
                }, 500);
            },
            gaodemapSubmit(params) {
                console.log("gaodemapSubmit", params)
                this.isShowMap = false;
                this.form.address=params.FullAddress;
                this.form.lng=params.Lng;
                this.form.lat=params.Lat;
            },
        }
    }
</script>
<style lang="scss" scoped>
    .searchHide {
        display: none !important;
        position: static !important;
    }
    .gaode-map {
        height: 500px;
        position: relative;
    }
</style>